import { SVGProps } from 'react'

export const Save = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={20}
		height={20}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m18.58 4.92-3.5-3.5a.58.58 0 0 0-.413-.17H3A1.75 1.75 0 0 0 1.25 3v14A1.75 1.75 0 0 0 3 18.75h14A1.75 1.75 0 0 0 18.75 17V5.333a.6.6 0 0 0-.17-.414m-6.247-2.503v3.5H7.667v-3.5zm-7 15.166V13.5a.583.583 0 0 1 .584-.583h8.166a.583.583 0 0 1 .584.583v4.083zM17.583 17a.583.583 0 0 1-.583.583h-1.167V13.5a1.75 1.75 0 0 0-1.75-1.75H5.917a1.75 1.75 0 0 0-1.75 1.75v4.083H3A.583.583 0 0 1 2.417 17V3A.583.583 0 0 1 3 2.417h3.5v3.5a1.167 1.167 0 0 0 1.167 1.166h4.666A1.167 1.167 0 0 0 13.5 5.917v-3.5h.928l3.155 3.156z"
			fill="currentColor"
		/>
	</svg>
)
